<template>
	<b-modal id="modal-note" :title="getTitle">
		<span class="close" @click="$bvModal.hide('modal-note')">
			<x-icon size="1.25x" class="custom-class"></x-icon>
		</span>
		<div class="main-area" v-if="note">
			<TextRenderer
				:note="note"
				v-if="note.type === 'text' || note.type === 'code'"
			>
			</TextRenderer>
			<BookmarkRenderer :note="note" v-if="note.type === 'bookmark'">
			</BookmarkRenderer>
			<CommentRenderer :note="note" :editable="true"></CommentRenderer>
			<!-- <Fields :note="note"></Fields> -->
		</div>
		<div class="sidebar-area" v-if="note">
			<p class="p-small muted">
				{{ formatDate(note.createdAt) }}
			</p>
			<BucketSelect
				v-if="buckets.length > 0"
				size="sm"
				:bucketId="note.bucket"
				@change="onBucketUpdate"
			>
			</BucketSelect>
			<FolderSelect
				v-if="folders.length > 0"
				size="sm"
				:folderId="note.folder"
				@change="onFolderUpdate"
			>
			</FolderSelect>
			<span class="btn btn-sm btn-danger" @click="deleteNote">
				Delete Note
			</span>
			<br />
			<code class="muted">{{ note.id }}</code>
		</div>
	</b-modal>
</template>

<script>
import { CheckIcon, XIcon } from 'vue-feather-icons';
import moment from 'moment';
import TextRenderer from '@/components/dashboard/text-renderer';
import BookmarkRenderer from '@/components/dashboard/bookmark-renderer';
import CommentRenderer from '@/components/dashboard/comment-renderer';
import Fields from '@/components/ui/fields';

import BucketSelect from '@/components/ui/bucket-select.vue';
import FolderSelect from '@/components/ui/folder-select.vue';

export default {
	components: {
		TextRenderer,
		BookmarkRenderer,
		CommentRenderer,
		Fields,
		XIcon,
		CheckIcon,
		BucketSelect,
		FolderSelect,
	},
	data: function () {
		var obj = {
			lock: false,
			bucket: {
				title: '',
				color: 2,
			},
			note: null,
		};
		return obj;
	},
	watch: {
		selectedNoteTrigger: function () {
			if (this.selectedNote) {
				this.note = this.selectedNote;
				this.$bvModal.show('modal-note');
			}
		},
	},
	computed: {
		getTitle: function () {
			if (!this.note) {
				return 'Annotation';
			}
			if (this.note) {
				return this.note.type;
			}
		},
		buckets: function () {
			return this.$store.getters['bucket/buckets'];
		},
		folders: function () {
			return this.$store.getters['folder/folders'];
		},
		selectedNoteTrigger: function () {
			return this.$store.getters['dashboard/selectedNoteTrigger'];
		},
		selectedNote: function () {
			return this.$store.getters['dashboard/selectedNote'];
		},
		comment: function () {
			if (this.note.comment && this.note.comment.raw) {
				return this.note.comment.html;
			} else {
				return false;
			}
		},
	},
	methods: {
		formatDate: function (date) {
			return moment(date).format('Do MMMM, YYYY');
		},
		onBucketUpdate: function (bucket) {
			if (bucket) {
				let temp = JSON.parse(JSON.stringify(this.selectedNote));
				temp.bucket = bucket._id;
				this.$store.dispatch('note/updateNote', temp);
			} else {
				let temp = JSON.parse(JSON.stringify(this.selectedNote));
				temp.bucket = null;
				this.$store.dispatch('note/updateNote', temp);
			}
		},
		onFolderUpdate: function (folder) {
			if (folder) {
				let temp = JSON.parse(JSON.stringify(this.selectedNote));
				temp.folder = folder._id;
				this.$store.dispatch('note/updateNote', temp);
			} else {
				let temp = JSON.parse(JSON.stringify(this.selectedNote));
				temp.folder = null;
				this.$store.dispatch('note/updateNote', temp);
			}
		},
		deleteNote: function () {
			this.$store.dispatch('note/removeNote', this.note.id);
			this.$bvModal.hide('modal-note');
		},
	},
	mounted: function () {},
};
</script>

<style lang="scss">
#modal-note___BV_modal_outer_ {
	.modal-dialog {
		max-width: 800px;
	}
	.update-item {
		margin-top: 10px;
	}

	.modal-body {
		display: flex;
	}

	.main-area {
		flex-grow: 1;
		margin-right: $lg-margins * 2;

		&__comment {
			margin-top: $lg-margins;
			font-size: var(--font-size-sm);
			opacity: 0.9;
		}
	}

	.sidebar-area {
		position: relative;
		width: 240px;
		min-width: 240px;
		padding-left: $lg-margins * 2;

		&:before {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			width: 1px;
			height: 100%;
			background-color: rgba(255, 255, 255, 0.1);
		}

		.c-bucket-select,
		.c-folder-select {
			width: 100%;
			margin-bottom: $lg-margins;

			.btn-group {
				width: 100%;
			}
			.btn {
				text-align: left;
			}
		}
	}

	@include media-breakpoint-down(sm) {
		.modal-body {
			flex-wrap: wrap;
		}
		.main-area {
			min-width: 100%;
			flex-grow: 1;
		}
		.sidebar-area {
			padding-left: 0;
			padding-top: var(--spacer-sm);
			margin-top: var(--spacer-sm);
			min-width: 100%;
			flex-grow: 1;

			&:before {
				width: 100%;
				height: 1px;
			}
		}
	}
}
</style>
